// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.



// WEBPACK FOOTER //
// ../../../src/add/operator/toPromise.ts